import { render } from "./EditSidebar.vue?vue&type=template&id=bc1216ea&scoped=true"
import script from "./EditSidebar.vue?vue&type=script&lang=js"
export * from "./EditSidebar.vue?vue&type=script&lang=js"

import "../../assets/scss/document_edit.scss?vue&type=style&index=0&id=bc1216ea&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc1216ea"]])

export default __exports__